<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
                @row-update="handleUpdate" @selection-change="handleSelectionChange" @size-change="pageSizeChange"
                @current-change="pageChange">
                <template slot-scope="scope" slot="menuLeft">
                    <el-button type="primary" icon="el-icon-plus" size="small" plain @click.stop="handleAdd()">新增
                    </el-button>
                    <el-button type="warning" icon="el-icon-delete" size="small" plain
                        @click.stop="handleDel('DELETE_OPTION', '逻辑删除')">删除</el-button>
                    <el-button type="danger" icon="el-icon-delete" size="small" plain
                        @click.stop="handleDel('DELETE_OPTION', '物理删除')">物理删除</el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button type="success" icon="el-icon-view" size="small" plain
                        @click.stop="handleDetail(scope.row, scope.index)">查看
                    </el-button>
                    <el-button type="primary" icon="el-icon-edit" size="small" plain
                        @click.stop="handleEdit(scope.row, scope.index)">编辑
                    </el-button>
                </template>
                <template slot-scope="scope" slot="firstClassifyNameForm">
                    <el-select v-model="classify" placeholder="请选择商品一级分类" required @change="chooseSecondClassify"
                        value-key="id">
                        <el-option v-for="classify in classifies" :key="classify.id" :label="classify.name"
                            :value="classify"></el-option>
                    </el-select>
                </template>
                <template slot-scope="scope" slot="secondClassifyNameForm">
                    <el-select v-model="secondClassify" placeholder="请选择商品二级分类" required @change="selectSecondClassify"
                        value-key="id">
                        <el-option v-for="secondClassify in secondClassifies" :key="secondClassify.id"
                            :label="secondClassify.name" :value="secondClassify"></el-option>
                    </el-select>
                </template>
                <template slot-scope="scope" slot="constituteForm">
                    <!-- <div> -->
                    <el-table :data="constitute" border>
                        <el-table-column prop="constituteName" align="center" label="SKU名称">
                            <template slot-scope="scope">
                                <el-input type="input" name="constituteName" v-model="scope.row.constituteName"
                                    :value="scope.row.constituteName" placeholder="请输入SKU名称"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="constituteCode" align="center" label="SKU编码">
                            <template slot-scope="scope">
                                <el-input type="input" name="constituteCode" v-model="scope.row.constituteCode"
                                    :value="scope.row.constituteCode" placeholder="请输入SKU编码"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作">
                            <template slot-scope="scope">
                                <el-button type="danger" icon="el-icon-delete" size="small" plain
                                    @click="handleSteppingDelete(scope.$index, scope.row)">删除
                                </el-button>
                                <el-button @click="handleAddRows()" type="primary" icon="el-icon-plus" size="small"
                                    plain>增加一行</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- </div> -->
                </template>
            </avue-crud>

        </basic-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { productSkuOption } from "@/const/salesCloud/productSkuOption";
import {
    findSkuList, addProductSku, updateProductSku, delProductSku
} from "@/api/salesCloud/productSku"
import { findClassifyAll, chooseSecondClassify } from "@/api/salesCloud/classifyA"
import { findByLabel } from "@/util/util"
import { DIC } from "@/const/dic"

export default {
    name: "productSku",
    data() {
        return {
            tableOption: productSkuOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            tabelObj: {},
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10 //每页显示多少条
            },
            grade: {
                box: false,
                check: []
            },
            classifies: [],
            classify: {},
            secondClassifies: [],
            secondClassify: {},
            constitute: []
        };
    },
    created() {

        findClassifyAll().then((res) => {
            let data = JSON.parse(res.data);
            this.classifies = data
        });

        this.handleList();
    },
    watch: {},
    mounted() {
    },
    computed: {
        ...mapGetters(["permission"])
    },
    props: [],
    methods: {
        handleAddRows() {
            let list = {
                constituteName: "",
                constituteCode: ''
            }
            this.constitute.unshift(list)
        },
        handleSteppingDelete(index) {
            this.constitute.splice(index, 1);
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm
            params.page = this.page.currentPage,
                params.size = pageSize
            findSkuList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize
                };
                this.tableLoading = false;
            })
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm
            params.page = page
            params.size = this.page.pageSize
            findSkuList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            })
        },
        searchChange(params) {
            this.tableLoading = true;
            // let params = this.$refs.crud.searchForm
            params.page = this.page.currentPage
            params.size = this.page.pageSize
            findSkuList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: params.page,
                    pageSize: params.size
                };
                this.tableLoading = false;
            })
        },
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm
            params.page = page.currentPage
            params.size = page.pageSize
            findSkuList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize
                };
                this.tableLoading = false;
            })
        },
        /**
         * @title 打开新增窗口
         * @detail 调用crud的handleadd方法即可
         *
         **/
        handleAdd() {
            this.constitute = [{}]
            this.$refs.crud.rowAdd();
        },
        handleEdit(row, index) {
            this.classify = { id: row.firstClassifyId }
            this.secondClassify = { id: row.secondClassifyId }
            chooseSecondClassify(this.classify.id).then((res) => {
                let data = JSON.parse(res.data);
                this.secondClassifies = data
            });

            this.constitute = row.list
            this.$refs.crud.rowEdit(row, index);


        },
        /**
         * @title 获取数据
         * @detail 赋值为tableData表格即可
         *
         **/
        handleList() {
            this.tableLoading = true;
            let parmas = {
                page: this.page.currentPage,
                size: this.page.pageSize
            }
            findSkuList(parmas).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            })
        },
        /**
         * @title 数据添加
         * @param row 为当前的数据
         * @param done 为表单关闭函数
         *
         **/
        handleSave(row, done) {
            row.firstClassifyId = this.classify.id
            row.secondClassifyId = this.secondClassify.id
            row.list = this.constitute
            console.log("data:" + row)
            addProductSku(row).then(response => {
                if (response.code == '200') {
                    this.$message({
                        showClose: true,
                        message: "添加成功",
                        type: "success"
                    });
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: response.message,
                        type: "error"
                    })
                }

            }).catch(error => {
                this.loading = false
                this.$message({
                    showClose: true,
                    message: error,
                    type: "error"
                })
            })
            done();
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange() {
            // console.log(val);
            // this.tableRow = val;
            // this.$notify({
            //     showClose: true,
            //     message: JSON.stringify(val),
            //     type: 'success',
            // });
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel(dicName, label) {
            if (this.$refs.crud.tableSelect.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择要操作的数据",
                    type: "error"
                })
                return
            }

            this.$confirm(`是否确认删除?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    let ids = new Array();
                    for (let row of this.$refs.crud.tableSelect) {
                        ids.push(row.id)
                    }

                    delProductSku(findByLabel(DIC.DELETE_OPTION, label), ids).then(response => {
                        if (response.code == '200') {
                            this.$message({
                                showClose: true,
                                message: "删除成功",
                                type: "success"
                            });
                            this.handleList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error"
                            })
                        }

                    }).catch(error => {
                        this.loading = false
                        this.$message({
                            showClose: true,
                            message: error,
                            type: "error"
                        })
                    })
                })
                .catch(() => { });
        },
        /**
         * @title 数据更新
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         * @param done 为表单关闭函数
         *
         **/
        handleUpdate(row, index, done) {
            row.firstClassifyId = this.classify.id
            row.secondClassifyId = this.secondClassify.id
            row.list = this.constitute
            updateProductSku(row).then(response => {
                if (response.code == '200') {
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: "success"
                    });
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: response.message,
                        type: "error"
                    })
                }

            }).catch(error => {
                this.loading = false
                this.$message({
                    showClose: true,
                    message: error,
                    type: "error"
                })
            })
            done();
        },
        handleDetail(row, index) {
            this.classify = { id: row.firstClassifyId }
            this.secondClassify = { id: row.secondClassifyId }
            chooseSecondClassify(this.classify.id).then((res) => {
                let data = JSON.parse(res.data);
                this.secondClassifies = data
            });

            this.constitute = row.list
            this.$refs.crud.rowView(row, index)

        },
        chooseSecondClassify() {
            chooseSecondClassify(this.classify.id).then((res) => {
                let data = JSON.parse(res.data);
                this.secondClassifies = data
            });
        },
        selectSecondClassify() {
            let list = [{
                constituteName: "",
                constituteCode: ''
            }]
            this.constitute = list
        }
    }

};
</script>

<style lang="scss">
.table-container {
    padding: 8px 10px;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}
</style>
